import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-chitreports',
  templateUrl: './chitreports.component.html',
  styleUrls: ['./chitreports.component.css']
})
export class ChitreportsComponent implements OnInit {

  commonUrl : string 
  
  constructor(private userService: UserService)  { 
    this.commonUrl = userService.rootUrl;
  }


  ngOnInit() {
  }


  DayReport(){
    window.open(this.commonUrl+'/Reports/Report.aspx?id=11');
  }

  BalReport(){
    window.open(this.commonUrl+'/Reports/Report.aspx?id=12');
  }

  AccStat(){
    window.open(this.commonUrl+'/Reports/Report.aspx?id=13');
  }

  PaymentVoucher(){
    window.open(this.commonUrl+'/Reports/Report.aspx?id=14');
  }

  RceiptVoucher(){
    window.open(this.commonUrl+'/Reports/Report.aspx?id=15');

  }

  transdaetails(){
    window.open(this.commonUrl+'/Reports/Report.aspx?id=16');
  }

  TransBasics(){
    window.open(this.commonUrl+'/Reports/Report.aspx?id=17');
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/chitreports/chitreports.component.ts